const controlPanelSharedStyle = `
    .streaming_content_list li.selected {
      border: 0;
      outline: 0;
    }
    .streaming_content_list li.disabled {
      opacity: 0.78;
      border: 1px dashed #3a3a42;
    }
    .streaming_content_list li.disabled a {
      cursor: default;
      margin-bottom: 0;
    }
    .streaming_channel_head {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 8px;
      margin-bottom: 10px;
    }
    .streaming_channel_main {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
      flex: 1;
      min-width: 0;
    }
    .streaming_channel_title {
      display: flex;
      align-items: center;
      margin-bottom: 0 !important;
      flex: 1;
      width: 100%;
      cursor: pointer;
      min-width: 0;
    }
    .streaming_channel_title span,
    .streaming_channel_title_text {
      font-size: 12px;
      color: #fff;
      line-height: 1.4;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 0;
    }
    .streaming_channel_actions {
      display: flex;
      align-items: flex-start;
      flex-shrink: 0;
    }
    .streaming_info_button {
      border: 0;
      padding: 0;
      margin: 0;
      background: transparent;
      color: #9ca3af;
      font-size: 10px;
      line-height: 1;
      cursor: pointer;
      flex-shrink: 0;
    }
    .streaming_info_button:hover {
      color: #d1d5db;
    }
    .streaming_channel_switch {
      margin-right: 0 !important;
    }
    .streaming_channel_switch input:disabled ~ span {
      cursor: not-allowed;
    }
    .streaming_channel_switch input:disabled ~ span::before {
      background-color: #3b3b40;
      border: 1px solid #4b4b52;
    }
    .streaming_channel_switch input:disabled ~ span::after {
      background-color: #7d7d87;
    }
    .streaming_content_list li.disabled .streaming_info_button {
      color: #7d7d87;
    }
    .streaming_content_list li.disabled .streaming_channel_title_text {
      cursor: default;
    }
    .streaming_top_action {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      margin-bottom: 16px;
    }
    .streaming_top_action .streaming_all_channels_text_button {
      margin-left: auto;
      margin-right: 8px;
    }
    .streaming_content_list li {
      padding-top: 12px;
      padding-bottom: 12px;
      padding-left: 10px;
      padding-right: 8px;
    }
    .streaming_card_status_row {
      margin-bottom: 8px;
      display: flex;
      align-items: center;
    }
    .streaming_card_status_badge {
      margin-left: 0 !important;
      min-width: 46px !important;
      height: 15px;
      padding: 0 3px !important;
      font-size: 9px;
      font-weight: 500;
      border-radius: 4px;
      text-transform: uppercase;
      align-self: flex-start;
    }
    .streaming_all_channels_text_button {
      border: 0;
      padding: 0;
      margin: 0;
      background: transparent;
      color: #9ca3af;
      font-size: 10px;
      line-height: 1;
      cursor: pointer;
    }
    .streaming_all_channels_text_button:hover {
      color: #d1d5db;
    }
    .streaming_channel_bottom_row {
      justify-content: space-between !important;
      align-items: center;
      margin-top: 6px;
    }
    .streaming_channel_bottom_row .streaming_channel_id_text,
    .streaming_channel_bottom_row .streaming_info_button {
      color: #8b8b90;
      font-size: 11px;
      line-height: 1.2;
      font-weight: 400;
    }
    .streaming_channel_bottom_row .streaming_info_button {
      border: 0;
      background: transparent;
      padding: 0;
      margin: 0;
      cursor: pointer;
    }
    .streaming_channel_bottom_row .streaming_info_button:hover {
      color: #8b8b90;
    }
    .streaming_channel_bottom_row > div span {
      margin-right: 0 !important;
    }
    .streaming_content_list li.streaming_empty_item {
      text-align: center;
      padding: 16px 8px;
      color: #8b8b90;
      font-size: 12px;
    }
    .streaming_content_list li.streaming_empty_item span {
      margin: 0;
      color: #8b8b90;
    }
    .streaming_status_badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 56px;
      height: 20px;
      padding: 0 8px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 600;
      line-height: 1;
      color: #d1d5db;
      background: #3b3b40;
      margin-left: 8px;
      white-space: nowrap;
    }
    .streaming_status_badge.status_ready {
      color: #22c55e;
      border: 1px solid #22c55e;
      background: rgba(34, 197, 94, 0.15);
    }
    .streaming_status_badge.status_reserved {
      color: #60a5fa;
      border: 1px solid #60a5fa;
      background: rgba(96, 165, 250, 0.15);
    }
    .streaming_status_badge.status_live {
      color: #f87171;
      border: 1px solid #f87171;
      background: rgba(248, 113, 113, 0.15);
    }
    .streaming_status_badge.status_suspended {
      color: #f59e0b;
      border: 1px solid #f59e0b;
      background: rgba(245, 158, 11, 0.15);
    }
    .streaming_status_badge.status_ended {
      color: #a1a1aa;
      border: 1px solid #a1a1aa;
      background: rgba(161, 161, 170, 0.15);
    }
    .streaming_channel_meta {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 4px;
      align-items: flex-end;
    }
    .streaming_channel_meta span {
      margin: 0;
      color: #8b8b90 !important;
      font-size: 10px;
      line-height: 1.3;
    }
    .streaming_help_box {
      border: 1px solid #1f1f24;
      background: #33343d;
      border-radius: 0;
      padding: 10px;
    }
    .streaming_help_box p {
      font-size: 11px;
      color: #8b8b90;
      line-height: 1.4;
      margin: 0 0 8px 0;
    }
    .streaming_help_box button {
      width: 100%;
      height: 30px;
      border-radius: 0;
      border: 0;
      background: #5959ef;
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      cursor: pointer;
    }
    .streaming_selected_title p {
      margin-top: 6px;
      font-size: 11px;
      color: #8b8b90;
    }
    .streaming_detail_panel .streaming_selected_title {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
      padding: 2px 0 10px;
      background: transparent;
      margin-bottom: 8px;
    }
    .control_content_detail.streaming_detail_panel {
      padding-left: 20px;
      padding-right: 18px;
    }
    .streaming_selected_title_tools {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    .streaming_detail_back_button {
      width: auto;
      height: 20px;
      border: 0;
      background: transparent;
      padding: 0;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: flex-start;
      gap: 4px;
    }
    .streaming_detail_back_button img {
      width: 10px;
      height: 10px;
      opacity: 0.9;
      display: block;
    }
    .streaming_detail_back_button span {
      color: #aeb4c5;
      font-size: 10px;
      line-height: 1;
      font-weight: 400;
      white-space: nowrap;
    }
    .streaming_detail_back_button:hover img {
      opacity: 1;
    }
    .streaming_detail_back_button:hover span {
      color: #d8ddee;
    }
    .streaming_detail_info_button {
      border: 0;
      background: transparent;
      padding: 0;
      margin: 0;
      margin-left: auto;
      color: #a7acbb;
      font-size: 11px;
      line-height: 1;
      font-weight: 400;
      cursor: pointer;
      white-space: nowrap;
      text-align: right;
    }
    .streaming_detail_info_button:hover {
      color: #d7dbea;
    }
    .streaming_detail_panel > .streaming_selected_title:first-child {
      padding-left: 0;
      padding-right: 0;
    }
    .streaming_detail_panel .streaming_selected_title h4 {
      margin: 0;
      font-size: 13px;
      line-height: 1.35;
      color: #ffffff;
      word-break: break-all;
      font-weight: 500;
    }
    .streaming_detail_panel .streaming_selected_title p {
      margin: 0;
      color: #8f93a1;
    }
    .streaming_panel_test_actions {
      display: flex;
      align-items: center;
      gap: 10px;
      margin: 8px 0 48px;
      padding: 8px 0;
      margin-left: -8px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    }
    .streaming_panel_test_label {
      display: inline-flex;
      align-items: center;
      color: #f3f4f6;
      font-size: 12px;
      line-height: 1;
      font-weight: 500;
      flex-shrink: 0;
      width: 68px;
    }
    .streaming_panel_test_switch {
      margin-right: 0 !important;
      flex-shrink: 0;
    }
    .streaming_panel_test_switch input:disabled ~ span::before {
      background-color: #3b3b40;
      border: 1px solid #4b4b52;
    }
    .streaming_panel_test_switch input:disabled ~ span::after {
      background-color: #7d7d87;
    }
    .streaming_panel_test_text {
      display: inline-flex;
      align-items: center;
      color: #9aa0b3;
      font-size: 11px;
      line-height: 1;
      font-weight: 500;
      margin-left: -2px;
    }
    .streaming_panel_test_text.active {
      color: #f3f4f6;
    }
    .streaming_panel_test_text.connecting {
      color: #60a5fa;
    }
    .streaming_detail_panel .streaming_detail_list {
      margin: 0;
      padding: 0;
      list-style: none;
    }
    .streaming_detail_panel .streaming_detail_list li {
      display: block !important;
      align-items: initial !important;
      justify-content: initial !important;
      gap: 0 !important;
      padding: 8px 0 !important;
      border-bottom: 0 !important;
    }
    .streaming_detail_panel .streaming_detail_list li + li {
      margin-top: 8px;
    }
    .streaming_detail_panel .streaming_detail_list li:last-child {
      cursor: default !important;
    }
    .streaming_detail_panel .streaming_detail_list li h5 {
      margin: 0;
      font-size: 11px;
      line-height: 1.3;
      color: #9aa0b3 !important;
      font-weight: 400 !important;
    }
    .streaming_detail_panel .streaming_detail_list li div {
      margin-top: 4px;
      text-align: left !important;
      height: auto !important;
    }
    .streaming_detail_panel .streaming_detail_list li div span {
      margin: 0;
      display: inline-block;
      max-width: 100%;
      font-size: 12px;
      line-height: 1.35;
      color: #f3f4f6 !important;
      font-weight: 400 !important;
      word-break: break-all;
    }
    .streaming_detail_panel .streaming_detail_list li .streaming_value_with_copy {
      position: static;
      display: inline;
      max-width: none;
      padding-right: 0;
    }
    .streaming_detail_panel .streaming_detail_list li .streaming_value_with_copy span {
      display: inline;
      max-width: none;
    }
    .streaming_inline_copy_button {
      width: 14px;
      height: 14px;
      border: 0;
      background: transparent;
      padding: 0;
      margin-top: 0;
      margin-left: 4px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      flex-shrink: 0;
      position: static;
      vertical-align: baseline;
    }
    .streaming_inline_copy_button img {
      width: 12px;
      height: 12px;
      opacity: 0.95;
      filter: brightness(0) invert(1);
      display: block;
    }
    .streaming_inline_copy_button:hover img {
      opacity: 1;
    }
    .streaming_inline_copy_done {
      font-size: 11px;
      line-height: 1;
      color: #22c55e;
      font-weight: 700;
    }
    .streaming_detail_actions {
      border-top: 0;
      padding: 8px 0 4px;
    }
    .streaming_detail_action_button {
      width: 100%;
      border: 0;
      background: transparent;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 12px;
      cursor: pointer;
    }
    .streaming_detail_action_button span {
      color: #b8bdca;
      font-size: 11px;
      line-height: 1.2;
      font-weight: 400;
    }
    .streaming_detail_action_button img {
      width: 11px;
      height: 11px;
      opacity: 0.7;
    }
    .streaming_detail_action_button:hover span {
      color: #e5e7eb;
    }
    .streaming_detail_action_button:hover img {
      opacity: 0.9;
    }
    .streaming_empty_state {
      padding: 16px;
      font-size: 12px;
      color: #8b8b90;
      text-align: center;
    }

    #consoleStreamingToggleOffConfirmModal,
    #consoleStreamingToggleSwitchConfirmModal {
      z-index: 1110;
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.52);
      overflow: hidden;
    }
    #consoleStreamingToggleOffConfirmModal .modal-dialog,
    #consoleStreamingToggleSwitchConfirmModal .modal-dialog {
      position: fixed !important;
      top: 120px !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
      width: 480px !important;
      max-width: 90vw !important;
      margin: 0 !important;
    }
    #consoleStreamingToggleOffConfirmModal .modal-content,
    #consoleStreamingToggleSwitchConfirmModal .modal-content {
      border: 1px solid #e5e7eb;
      border-radius: 12px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }
    #consoleStreamingToggleOffConfirmModal .modal-base .modal-header,
    #consoleStreamingToggleSwitchConfirmModal .modal-base .modal-header {
      border-bottom: 0;
      padding: 18px 20px 14px;
    }
    #consoleStreamingToggleOffConfirmModal .modal-base-head-row,
    #consoleStreamingToggleSwitchConfirmModal .modal-base-head-row {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      width: 100%;
    }
    #consoleStreamingToggleOffConfirmModal .modal-base-head-copy,
    #consoleStreamingToggleSwitchConfirmModal .modal-base-head-copy {
      min-width: 0;
      flex: 1;
    }
    .modal-base-body-flow {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
    .modal-base-description {
      font-size: 13px;
      line-height: 20px;
      color: #475569;
    }
    #consoleStreamingToggleOffConfirmModal .modal-base-close,
    #consoleStreamingToggleSwitchConfirmModal .modal-base-close {
      width: 36px;
      height: 36px;
      flex-shrink: 0;
    }
    #consoleStreamingToggleOffConfirmModal .modal-footer,
    #consoleStreamingToggleSwitchConfirmModal .modal-footer {
      border-top: 0;
      padding: 10px 20px 20px;
      background: #fff;
    }
    #consoleStreamingToggleOffConfirmModal .modal-base-footer,
    #consoleStreamingToggleSwitchConfirmModal .modal-base-footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 8px;
      width: 100%;
    }

    #consoleStreamingChannelDetailModal {
      z-index: 1110;
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.52);
      overflow: hidden;
    }
    #consoleStreamingChannelDetailModal .modal-dialog {
      position: fixed !important;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%) !important;
      max-width: 960px;
      width: calc(100% - 40px);
      margin: 0 !important;
    }
    #consoleStreamingChannelDetailModal .modal-content {
      border: 1px solid #e5e7eb;
      border-radius: 12px;
      overflow: hidden;
      background: #fff;
      max-height: calc(100vh - 32px);
      display: flex;
      flex-direction: column;
      box-shadow: 0 20px 60px rgba(15, 23, 42, 0.12);
    }
    #consoleStreamingChannelDetailModal .modal-base .modal-header {
      border-bottom: 0;
      padding: 16px 20px;
      background: #f8fafc;
    }
    #consoleStreamingChannelDetailModal .modal-base-head-row {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 12px;
      width: 100%;
    }
    #consoleStreamingChannelDetailModal .modal-base-head-copy {
      min-width: 0;
      flex: 1;
    }
    #consoleStreamingChannelDetailModal .modal-base .MuiTypography-modaltitle {
      margin: 0;
      font-size: 20px !important;
      line-height: 1.2;
      color: #111827;
      font-weight: 700;
    }
    #consoleStreamingChannelDetailModal .modal-base-close {
      width: 32px;
      height: 32px;
      border: 0;
      border-radius: 999px;
      background: transparent;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
    #consoleStreamingChannelDetailModal .modal-body {
      padding: 16px 20px 12px;
      max-height: calc(100vh - 220px);
      overflow-y: auto;
      background: #fff;
      flex: 1 1 auto;
    }
    #consoleStreamingChannelDetailModal .modal-footer {
      border-top: 0;
      padding: 12px 20px 16px;
      background: #f8fafc;
    }
    #consoleStreamingChannelDetailModal .modal-base-footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 100%;
    }
    #consoleStreamingChannelDetailModal .modal-base-footer-left {
      flex: 1;
    }
    #consoleStreamingAllChannelsModal {
      z-index: 1110;
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.52);
      overflow: hidden;
    }
    #consoleStreamingAllChannelsModal .modal-dialog {
      position: fixed !important;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%) !important;
      max-width: 980px;
      width: calc(100% - 40px);
      margin: 0 !important;
    }
    #consoleStreamingAllChannelsModal .modal-content {
      border: 1px solid #e5e7eb;
      border-radius: 12px;
      overflow: hidden;
      background: #fff;
      max-height: calc(100vh - 32px);
      display: flex;
      flex-direction: column;
      box-shadow: 0 20px 60px rgba(15, 23, 42, 0.12);
    }
    #consoleStreamingAllChannelsModal .modal-base .modal-header {
      border-bottom: 0;
      padding: 16px 20px;
      background: #f8fafc;
    }
    #consoleStreamingAllChannelsModal .modal-base-head-row {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 12px;
      width: 100%;
    }
    #consoleStreamingAllChannelsModal .modal-base-head-copy {
      min-width: 0;
      flex: 1;
    }
    #consoleStreamingAllChannelsModal .modal-base .MuiTypography-modaltitle {
      margin: 0;
      font-size: 20px !important;
      line-height: 1.2;
      color: #111827;
      font-weight: 700;
    }
    #consoleStreamingAllChannelsModal .modal-base-close {
      width: 32px;
      height: 32px;
      border: 0;
      border-radius: 999px;
      background: transparent;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
    #consoleStreamingAllChannelsModal .modal-body {
      padding: 16px 20px 12px;
      max-height: calc(100vh - 220px);
      overflow-y: auto;
      background: #fff;
      flex: 1 1 auto;
    }
    #consoleStreamingAllChannelsModal .modal-footer {
      border-top: 0;
      padding: 12px 20px 16px;
      background: #f8fafc;
    }
    #consoleStreamingAllChannelsModal .modal-base-footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 100%;
    }
    #consoleStreamingAllChannelsModal .modal-base-footer-left {
      flex: 1;
    }
    .streaming_all_channels_modal_body {
      width: 100%;
      border: 1px solid #e5e7eb;
      border-radius: 10px;
      overflow: hidden;
      background: #fff;
    }
    .streaming_all_channels_toolbar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 12px;
      padding: 12px 16px;
      background: #fff;
      border-bottom: 1px solid #e5e7eb;
    }
    .streaming_all_channels_toolbar_left,
    .streaming_all_channels_toolbar_right {
      display: flex;
      align-items: center;
    }
    .streaming_all_channels_filter_select {
      height: 32px;
      min-width: 126px;
      border: 1px solid #d0d5dd;
      border-radius: 8px;
      background: #fff;
      color: #344054;
      font-size: 13px;
      padding: 0 10px;
      outline: none;
      cursor: pointer;
    }
    .streaming_all_channels_search_wrap {
      width: 220px;
      height: 32px;
      border: 1px solid #d0d5dd;
      border-radius: 8px;
      background: #fff;
      display: inline-flex;
      align-items: center;
      padding: 0 10px;
      gap: 6px;
      box-sizing: border-box;
    }
    .streaming_all_channels_search_wrap .MuiSvgIcon-root {
      width: 16px;
      height: 16px;
      color: #64748b;
      flex-shrink: 0;
    }
    .streaming_all_channels_search_wrap input {
      width: 100%;
      border: 0;
      outline: none;
      background: transparent;
      color: #464f60;
      font-size: 13px;
      line-height: 1;
    }
    .streaming_all_channels_search_wrap input::placeholder {
      color: #b7b7bd;
    }
    .streaming_all_channels_table {
      width: 100%;
      border-collapse: collapse;
      background: #fff;
      table-layout: fixed;
    }
    .streaming_all_channels_table th,
    .streaming_all_channels_table td {
      border-bottom: 1px solid #e5e7eb;
      padding: 12px 16px;
      text-align: left;
      vertical-align: middle;
      white-space: nowrap;
    }
    .streaming_all_channels_table th:first-child,
    .streaming_all_channels_table td:first-child {
      padding-left: 24px;
    }
    .streaming_all_channels_table th:last-child,
    .streaming_all_channels_table td:last-child {
      padding-right: 24px;
    }
    .streaming_all_channels_table th {
      background: #f8fafc;
      color: #98a2b3;
      font-size: 11px;
      font-weight: 400;
      line-height: 16px;
      height: 36px;
    }
    .streaming_all_channels_table td {
      color: #344054;
      font-size: 13px;
      line-height: 18px;
      font-weight: 400;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .streaming_all_channels_table th:nth-child(1),
    .streaming_all_channels_table td:nth-child(1) {
      width: 120px;
    }
    .streaming_all_channels_table td:nth-child(2) {
      max-width: 280px;
      white-space: normal;
      word-break: break-all;
    }
    .streaming_all_channels_table th:nth-child(4),
    .streaming_all_channels_table td:nth-child(4) {
      width: 128px;
    }
    .streaming_all_channel_name_cell {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2px;
    }
    .streaming_all_channel_name_button {
      border: 0;
      background: transparent;
      margin: 0;
      padding: 0;
      color: #344054;
      font-size: 13px;
      line-height: 18px;
      font-weight: 500;
      text-align: left;
      cursor: pointer;
    }
    .streaming_all_channel_name_button:hover {
      color: #334155;
      text-decoration: underline;
    }
    .streaming_all_channel_console_link {
      color: #667085;
      font-size: 11px;
      line-height: 1.25;
      text-decoration: none;
      cursor: pointer;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .streaming_all_channel_console_link:hover {
      color: #475467;
      text-decoration: underline;
    }
    .streaming_all_channel_console_link.is-empty {
      pointer-events: none;
      text-decoration: none;
    }
    .streaming_all_channels_table td:nth-child(5) {
      width: 96px;
      white-space: normal;
      word-break: break-all;
    }
    .streaming_all_channels_table td:nth-child(6) {
      width: 96px;
      white-space: normal;
      word-break: break-all;
    }
    .streaming_all_channel_session_cell {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2px;
    }
    .streaming_all_channel_session_name {
      color: #344054;
      font-size: 13px;
      line-height: 18px;
    }
    .streaming_all_channel_session_datetime {
      color: #94a3b8;
      font-size: 11px;
      line-height: 1.25;
    }
    .streaming_all_channels_table td:last-child {
      width: 52px;
      text-align: center;
      padding-left: 12px;
      padding-right: 12px;
    }
    .streaming_all_channels_table tbody tr:hover td {
      background: #f5f5ff;
    }
    .streaming_all_channels_table tbody tr:last-child td {
      border-bottom: 0;
    }
    .streaming_table_status_with_dot {
      display: flex;
      align-items: center;
      gap: 8px;
      line-height: 1;
    }
    .streaming_table_status_with_dot .status-dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      display: inline-block;
      flex-shrink: 0;
    }
    .streaming_table_status_with_dot span:last-child {
      color: #344054;
      font-size: 13px;
      line-height: 18px;
      font-weight: 400;
      letter-spacing: 0.01em;
    }
    .streaming_all_channel_action_icon_button {
      border: 0;
      background: transparent;
      margin: 0;
      padding: 0;
      width: 20px;
      height: 20px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: #6b7280;
      cursor: pointer;
    }
    .streaming_all_channel_action_icon_button .MuiSvgIcon-root {
      width: 20px;
      height: 20px;
    }
    .streaming_all_channel_action_icon_button:hover {
      color: #374151;
    }
    .streaming_all_channel_readonly {
      color: #94a3b8;
      font-size: 11px;
      line-height: 1;
      white-space: nowrap;
    }
    .streaming_all_channels_empty_row {
      text-align: center !important;
      color: #94a3b8 !important;
      padding: 32px 16px !important;
      background: #fff !important;
    }
    #consoleStreamingReserveConfirmModal {
      z-index: 1112;
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.52);
      overflow: hidden;
    }
    #consoleStreamingReserveConfirmModal .modal-dialog {
      position: fixed !important;
      top: 220px !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
      max-width: 420px;
      width: calc(100% - 40px);
      margin: 0 !important;
    }
    #consoleStreamingReserveConfirmModal .modal-content {
      border: 1px solid #e5e7eb;
      border-radius: 12px;
      overflow: hidden;
      background: #fff;
    }
    #consoleStreamingReserveConfirmModal .modal-base .modal-header {
      border-bottom: 0;
      padding: 18px 20px 12px;
    }
    #consoleStreamingReserveConfirmModal .modal-base .MuiTypography-modaltitle {
      margin: 0;
      font-size: 20px !important;
      line-height: 1.2;
      color: #111827;
      font-weight: 700;
    }
    #consoleStreamingReserveConfirmModal .modal-base .modal-base-subtitle {
      margin-top: 4px;
      color: #64748b;
      opacity: 0.75;
      font-size: 12px;
      line-height: 1.4;
    }
    #consoleStreamingReserveConfirmModal .modal-base-close {
      width: 32px;
      height: 32px;
      border: 0;
      border-radius: 6px;
      background: #fff;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
    #consoleStreamingReserveConfirmModal .modal-body {
      padding: 4px 20px 4px;
      background: #fff;
    }
    #consoleStreamingReserveConfirmModal .modal-footer {
      border-top: 0;
      padding: 10px 20px 20px;
      background: #fff;
    }
    .streaming_reserve_confirm_body p {
      margin: 0 0 6px;
      color: #475569;
      font-size: 13px;
      line-height: 1.4;
      word-break: break-all;
    }
    .streaming_reserve_confirm_body p:last-child {
      margin-bottom: 0;
    }
    .streaming_reserve_confirm_body p strong {
      display: inline-block;
      margin-right: 6px;
      color: #1f2937;
      font-weight: 600;
    }
    .streaming_reserve_confirm_actions {
      display: inline-flex;
      align-items: center;
      gap: 8px;
    }
    .streaming_modal2_confirm_button {
      min-width: 72px;
      height: 32px;
      border: 0;
      border-radius: 6px;
      padding: 0 14px;
      background: #5959ef;
      color: #fff;
      font-size: 13px;
      cursor: pointer;
    }
    .streaming_modal2_confirm_button:hover {
      background: #4d4de4;
    }
    .streaming_modal2_close_button {
      min-width: 64px;
      height: 32px;
      border: 1px solid #d0d5dd;
      border-radius: 8px;
      padding: 0 14px;
      background: #fff;
      color: #344054;
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
    }
    .streaming_modal2_close_button:hover {
      background: #f8fafc;
    }
    .streaming_modal2_content {
      display: flex;
      flex-direction: column;
      gap: 18px;
    }
    .streaming_modal2_tabs {
      display: flex;
      align-items: center;
      gap: 18px;
      border-bottom: 1px solid #e5e7eb;
      padding-bottom: 10px;
    }
    .streaming_modal2_tab_button {
      border: 0;
      padding: 0 0 8px;
      margin: 0;
      background: transparent;
      color: #64748b;
      font-size: 14px;
      cursor: pointer;
      border-bottom: 2px solid transparent;
      font-weight: 500;
    }
    .streaming_modal2_tab_button.active {
      color: #1f2937;
      border-bottom-color: #1f2937;
      font-weight: 600;
    }
    .streaming_modal2_sections {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
    .streaming_modal2_section_box {
      border: 1px solid #e5e7eb;
      border-radius: 12px;
      padding: 20px;
      background: #fff;
    }
    .streaming_modal2_section_box h4 {
      margin: 0 0 14px 0;
      color: #101828;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
    }
    .streaming_modal2_grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 24px 32px;
    }
    .streaming_modal2_field {
      min-width: 0;
    }
    .media-center-field {
      margin-bottom: 12px;
    }
    .streaming_modal2_field h5 {
      margin: 0 0 10px 0;
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 13px;
      line-height: 18px;
      font-weight: 500;
      color: #344054;
    }
    .streaming_modal2_value {
      margin: 0;
      font-size: 14px;
      line-height: 20px;
      color: #98a2b3;
      word-break: break-all;
    }
    .streaming_modal2_field p {
      margin: 0;
      font-size: 14px;
      line-height: 20px;
      color: #98a2b3;
      word-break: break-all;
    }
    .media-center-info-icon {
      width: 14px;
      height: 14px;
      border-radius: 50%;
      border: 1px solid #d0d5dd;
      background: #f8fafc;
      color: #667085;
      font-size: 10px;
      line-height: 14px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      cursor: default;
      flex-shrink: 0;
    }
    .streaming_modal2_value_with_action {
      display: flex;
      align-items: center;
      gap: 2px;
    }
    .streaming_modal2_value_with_action button,
    .streaming_copy_icon_button {
      border: 0;
      background: transparent;
      color: #6b7280;
      font-size: 11px;
      cursor: pointer;
      padding: 0;
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
    .streaming_copy_icon_button img {
      width: 12px;
      height: 12px;
      opacity: 0.6;
      display: block;
    }
    .streaming_modal2_usage p {
      margin: 0 0 12px;
      font-size: 13px;
      line-height: 20px;
      color: #667085;
    }
    .streaming_modal2_usage_table {
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #e5e7eb;
      border-radius: 10px;
      background: #fff;
      overflow: hidden;
    }
    .streaming_modal2_usage_table th,
    .streaming_modal2_usage_table td {
      border-bottom: 1px solid #e5e7eb;
      padding: 12px 10px;
      text-align: center;
    }
    .streaming_modal2_usage_table th {
      background: #f8fafc;
      color: #98a2b3;
      font-size: 11px;
      line-height: 16px;
      font-weight: 400;
    }
    .streaming_modal2_usage_table td {
      font-size: 13px;
      line-height: 18px;
      color: #475467;
    }
    .streaming_modal2_usage_table td.text-left {
      text-align: left;
    }
    .streaming_modal2_usage_table tbody tr:last-child td {
      border-bottom: 0;
    }
    .streaming_modal_dim {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.62);
      z-index: 1100;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px;
      box-sizing: border-box;
    }
    .streaming_modal {
      width: 460px;
      max-width: 100%;
      max-height: 85vh;
      border-radius: 10px;
      overflow: hidden;
      background: #202026;
      border: 1px solid #34343a;
      box-shadow: 0 24px 40px rgba(0, 0, 0, 0.42);
    }
    .streaming_modal.streaming_modal_wide {
      width: 760px;
    }
    .streaming_modal_head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 14px 16px;
      border-bottom: 1px solid #33333a;
    }
    .streaming_modal_head h3 {
      font-size: 14px;
      color: #fff;
      margin: 0;
      font-weight: 500;
    }
    .streaming_modal_head button {
      border: 0;
      background: transparent;
      color: #c5c7cf;
      font-size: 12px;
      cursor: pointer;
      padding: 0;
    }
    .streaming_modal_body {
      padding: 14px 16px;
      max-height: calc(85vh - 53px);
      overflow-y: auto;
    }
    .streaming_modal_body ul {
      margin: 0;
      padding: 0;
      list-style: none;
    }
    .streaming_modal_body ul li {
      border-bottom: 1px solid #2f2f35;
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
      gap: 10px;
    }
    .streaming_modal_body ul li:last-child {
      border-bottom: 0;
    }
    .streaming_modal_body ul li strong {
      font-size: 12px;
      color: #a0a0aa;
      flex-shrink: 0;
    }
    .streaming_modal_body ul li span {
      font-size: 12px;
      color: #fff;
      text-align: right;
      word-break: break-all;
    }
    .streaming_channel_table {
      width: 100%;
      border-collapse: collapse;
    }
    .streaming_channel_table th,
    .streaming_channel_table td {
      border-bottom: 1px solid #2f2f35;
      padding: 8px 6px;
      font-size: 11px;
      text-align: left;
      color: #fff;
      vertical-align: middle;
    }
    .streaming_channel_table th {
      color: #8b8b90;
      font-weight: 500;
    }
`;

export default controlPanelSharedStyle;
